const {
  Method,
  PaymentMethod,
} = require("@olga-food/schemas/lib/classes/schemas/order/payment/Payment");

const PaymentMethodEnum = [
  { value: PaymentMethod.CREDIT, label: "CREDIT" },
  { value: PaymentMethod.DEBIT, label: "DEBIT" },
  {
    value: PaymentMethod.VOUCHER,
    label: "VOUCHER",
  },
];

const SUPPORTED_BRANDS = [
  "VISA",
  "MASTERCARD",
  "DINERS",
  "AMEX",
  "HIPERCARD",
  "ELO",
  "AURA",
  "DISCOVER",
  "VR_BENEFICIOS",
  "SODEXO",
  "TICKET",
  "GOOD_CARD",
  "BANESCARD",
  "SOROCARD",
  "POLICARD",
  "VALECARD",
  "AGICARD",
  "JCB",
  "CREDSYSTEM",
  "CABAL",
  "GREEN_CARD",
  "VEROCHEQUE",
  "AVISTA",
];

const MUST_RETURN_BRAND = ["CREDIT", "DEBIT", "MEAL_VOUCHER", "FOOD_VOUCHER"];

export class NetLogicPaymentMethod {
  payer = null;
  constructor({ tenderMedia, ...payer }) {
    this.payer = payer;
    this.tenderMedia = tenderMedia;
  }

  // Campo privado
  get isOnline() {
    const { paymentMethod } = this.payer;
    return (PaymentMethod.ONLINE & paymentMethod) == PaymentMethod.ONLINE;
  }

  get brand() {
    const { method } = this.payer;
    if (this.type == "PREPAID" && MUST_RETURN_BRAND.includes(this.method)) {
      if (SUPPORTED_BRANDS.includes(method)) {
        return method;
      }
      return "OTHER";
    }
    return null;
  }

  get methodInfo() {
    const { method } = this.payer;
    return Method[method].name;
  }

  get nsu() {
    return "";
  }

  get value() {
    return this.payer.amount.toFixed(2);
  }

  get prepaid() {
    return true;
  }

  get issuer() {
    return "AUTOAT";
  }

  get collector() {
    return "AUTOAT";
  }

  get name() {
    return "AUTOATENDIMENTO";
  }

  get code() {
    return "AA";
  }

  export() {
    return {
      name: this.name,
      code: this.code,
      value: this.value,
      prepaid: this.prepaid,
      issuer: this.issuer,
      collector: this.collector,
      NSU: this.nsu,
      tenderMedia: this.tenderMedia,
    };
  }
}
